import { useAtom } from "jotai"
import { useEffect, useState } from "react"
import { recipientIdAtom, showIndividualMessageBoxAtom, showMessageBoxAtom, userAtom } from "../../store"
import { getUserData } from "../../firebase/users"

const SidebarChat = () => {
    const [userData, setUserData] = useAtom(userAtom)
    const [showMessageBox, setShowMessageBox] = useAtom(showMessageBoxAtom)
    const [showIndividualMessageBox, setShowIndividualMessageBox] = useAtom(showIndividualMessageBoxAtom)
    const [recipients, setRecipients] = useState([])
    const [recipientId, setRecipientId] = useAtom(recipientIdAtom)

    useEffect(() => {
        if (userData && userData.id) {
            let temp = userData.recipients ? [...userData.recipients] : []
            setRecipients(temp)
        }
    }, [userData])

    const showIndividualChat = (recipientId) => {
        setRecipientId(recipientId)
        setShowMessageBox(false)
        setShowIndividualMessageBox(true)
    }

    const getUnReadMessagesCount = (senderId) => {
        return userData.unReadMessages.filter(item => item.senderId === senderId).length
    }

    return (
        showMessageBox &&
        <>
            <div className="fixed right-0 z-[9999] bg-[#181818] md:w-[726px] w-full h-full md:px-6 py-8 max-md:top-[69px] border-l-[1px] border-gray">
                <div className="flex justify-between">
                    <div className="flex max-md:px-4">
                        <img src="/assets/icons/icon-logo.svg" alt="user" className="mr-3" />

                        <span className="uppercase text-white">Your Chats ({recipients.length})</span>
                    </div>

                    <button onClick={() => setShowMessageBox(false)}>
                        <img src="/assets/icons/icon-close-white.svg" alt="close" />
                    </button>
                </div>

                <hr className="border-gray my-6 max-md:hidden"></hr>

                {
                    recipients.length > 0 ?
                        <>
                            <div className="pl-9 py-4 text-white uppercase font-aero bg-primary max-md:mt-6">
                                Recent Chats
                            </div>

                            <div className="md:border-[1px] md:border-gray pt-4 md:pb-4 md:px-6 px-4 uppercase text-xs text-[#7F8289]">
                                <div className="relative flex">
                                    <div>Users</div>
                                    <div className="left-[390px] absolute max-md:hidden">Message Date</div>
                                </div>
                            </div>

                            <div className="border-gray py-4 md:px-6 px-2 text-xs text-[#7F8289] md:border-x-[1px] md:border-b-[1px]">
                                {
                                    recipients.map((item, index) =>
                                        <div
                                            className={`relative border-style-decoration chat-box p-3 text-xs text-white flex max-md:justify-between items-center hover:bg-white cursor-pointer hover:text-black ${index < recipients.length - 1 ? 'mb-3' : ''}`}
                                            key={`recipient-${item.id}`}
                                        >
                                            <div className="flex items-center">
                                                <img src="/assets/avatars/default.png" className="w-10 h-10 mr-3" alt="user" />

                                                {item.displayName}

                                                {
                                                    getUnReadMessagesCount(item.id) > 0 &&
                                                    <div className="flex ml-2 bg-[#f00] rounded-[50%] w-5 h-5">
                                                        <div className="w-full text-center text-white text-[12px]">{getUnReadMessagesCount(item.id)}</div>
                                                    </div>
                                                }
                                            </div>

                                            <div className="left-[390px] absolute max-md:hidden">
                                                28 Jan, 2024
                                            </div>

                                            <button className="border-style-decoration px-8 py-3 md:absolute md:left-[510px]" onClick={() => showIndividualChat(item.id)}>
                                                Chat
                                            </button>
                                        </div>
                                    )
                                }
                            </div>
                        </> :
                        <div className="text-center text-white">
                            No recent chats
                        </div>
                }
            </div>

            <div className="fixed max-md:hidden inset-0 z-[9998] bg-[#000] backdrop-blur-sm bg-opacity-75 transition-opacity" onClick={() => setShowMessageBox(false)}>

            </div>
        </>
    )
}

export default SidebarChat